import { Button, Modal, Input } from 'antd';
import React, { useEffect, useState } from 'react';
const { TextArea } = Input;

const TemplateAddModal = ({ data, dataSetter }) => {

    const [template, setTemplate] = useState(null);

    const closeModal = () => {
        dataSetter((prev) => ({
            ...prev,
            index: null,
            addModalOpen: false
        }))
    }



    const saveNewTemplate = () => {
        if (data?.index !== undefined && data?.index !== null) {
            data?.setFollowupTemplates((prev) => {
                const updated = [...prev];
                updated[data?.index] = template;
                return updated;
            });
            closeModal();
        } else {
            data?.setFollowupTemplates((prev) => ([...prev, template]));
            closeModal();
        }
    }


    useEffect(() => {
        setTemplate(data?.followupTemplates[data?.index])
    }, [data?.addModalOpen]);

    return (
        <>
            <Modal
                title={data?.index != null ? "Edit Template" : "Add new template"}
                centered
                open={data?.addModalOpen}
                onCancel={closeModal}
                maskClosable={false}
                width={800}
                footer={
                    <div className="flex justify-end">
                        <Button type="primary" onClick={() => saveNewTemplate()}>
                            Save
                        </Button>
                    </div>}
            >
                <div className='border rounded p-2 drop-shadow' style={{
                    backgroundColor: "#f7f7f7"
                }}>
                    <TextArea rows={8} placeholder="Type the template here" value={template} onChange={(e) => setTemplate(e.target.value)} />
                </div>
            </Modal>


        </>
    );
};

export default TemplateAddModal;
